module.exports = __webpack_public_path__ + "img/icon_2_19.ee2e54d6.png";